
function setMultiLineText(objKey, targetId) {
  // const multiLineText = pro_obj[objKey].multi_line;
  const modifiedText = objKey.replace(/(\r\n|\r|\n)/g, "<br>");
  document.getElementById(targetId).innerHTML = modifiedText;
}

function setImage2(imageUrl, id) {
  // Find the target element by its ID
  const targetElement = document.getElementById(id);

  // Append the <img> element to the target element

    targetElement.src = imageUrl;

}


function setImage(imageUrl, id) {
  // Create the <img> element
  const imgElement = document.createElement('img');

  // Set the src attribute
  imgElement.src = imageUrl;

  // Find the target element by its ID
  const targetElement = document.getElementById(id);

  // Append the <img> element to the target element
  if (targetElement) {
    console.log(imgElement);
    while (targetElement.firstChild) {
      targetElement.removeChild(targetElement.firstChild);
    }

    targetElement.appendChild(imgElement);

    // targetElement.innerHTML =imgElement;
  } else {
    console.error('Target element not found.');
  }
}

function change_url(objectKey, id) {

  let element = document.getElementById(id);
  element.setAttribute("href", objectKey);
}


function setProduct_data(objectKey, targetId , index) {


  if (objectKey.type == "multi_line_text_field" || objectKey.type == "single_line_text_field") {

    const modifiedText = objectKey.value.replace(/(\r\n|\r|\n)/g, "<br>");
    document.getElementById(targetId).innerHTML = modifiedText;
  } else if (objectKey.type == "file_reference") {
    setImage(objectKey.value, targetId);
  }else if(objectKey.type == "url"){
    // change_url(objectKey.value, objectKey.id);
  }

}



const render_product = (val, productIndex, index) => {
  console.log(`ref_prod_price${index}`);
  // Find the product with the matching ID
  const foundProduct = pro_obj[val];

  if (foundProduct) {
    console.log("Product found:", foundProduct);

    // Set image
    setImage2(foundProduct.image, productIndex + "image");

    //set product price
    if ( document.getElementById(`ref_prod_price${index}`)) {
    document.getElementById(`ref_prod_price${index}`).innerText = foundProduct.ref_pro_price;
    }
    // change url
    change_url(foundProduct.ref_product, "product_ref"+ index);
    change_url(foundProduct.additional_info_link, "additional"+ index);

    // Iterate over all_field keys
    for (var field in foundProduct.all_field) {
      if (foundProduct.all_field.hasOwnProperty(field)) {
        // console.log(field + index);

        // setMultiLineText(foundProduct.all_field[field].value, field + index);

        // set all data
        setProduct_data(foundProduct.all_field[field], field + index ,index);
      }
    }
  }
};

